module.exports = __webpack_public_path__ + "static/media/logo_blue_white.51e02ab7.png";